module.exports = __webpack_public_path__ + "static/media/social-stream.c6d4a37d.png";